import { ooFetchWithResponse } from './ooFetchWithResponse';

let statsApi = {
    getStats: async (startDate, endDate) => {
        let url = 'stats/v1?startDate=' + startDate + '&endDate=' + endDate;
        let response = await ooFetchWithResponse(url, {
            method: 'GET',
        });
        return response;
    }
}

export { statsApi };